export default (fn, wait = 100) => {
  let timeout
  return function () {
    const context = this
    const args = arguments
    clearTimeout(timeout)
    timeout = setTimeout(function () {
      timeout = null
      fn.apply(context, args)
    }, wait)
  }
}
